import Cookies from "js-cookie";

/**
 * Parse a cookie value the app wrote with `JSON.stringify` without ever
 * throwing. A corrupt cookie (an older build's raw string, the literal
 * `"undefined"` produced by `JSON.stringify(undefined)`, truncated JSON) used
 * to throw inside `JSON.parse` at module load and white-screen the whole app
 * until the user cleared cookies.
 *
 * @param {string|undefined} raw       Raw cookie value.
 * @param {object}           [options]
 * @param {*}                [options.fallback=null]  Returned when the value is
 *                           missing, null-ish, or cannot be parsed.
 * @param {boolean}          [options.allowRaw=false] When true, a value that is
 *                           not JSON is returned as the raw string instead of
 *                           the fallback (legacy token cookies were stored raw).
 */
export function parseCookieValue(raw, { fallback = null, allowRaw = false } = {}) {
  if (raw === undefined || raw === null) return fallback;
  const text = `${raw}`;
  if (!text || text === "undefined" || text === "null") return fallback;
  try {
    const parsed = JSON.parse(text);
    return parsed === null || parsed === undefined ? fallback : parsed;
  } catch {
    return allowRaw ? text : fallback;
  }
}

/**
 * Read + parse a cookie by name. Never throws.
 * @param {string} name
 * @param {{ fallback?: *, allowRaw?: boolean }} [options]
 */
export function safeParseCookie(name, options) {
  let raw;
  try {
    raw = Cookies.get(name);
  } catch {
    raw = undefined;
  }
  return parseCookieValue(raw, options);
}

export default safeParseCookie;
